export default __webpack_public_path__ + "static/media/coflogo.a9e5599e.png";